<template>
  <AvatarContainer
    class="mr-5"
    id="app-user-menu-activator"
    size="medium"
    :name="userProfileStore.userProfile.name ?? ''"
  />

  <v-menu
    activator="#app-user-menu-activator"
    location="bottom end"
    :close-on-content-click="true"
    class="rounded-lg user-menu"
  >
    <v-card class="pa-3 d-flex flex-column align-start">
      <div class="pa-2 d-flex align-center">
        <AvatarContainer
          class="mr-3"
          size="large"
          :name="userProfileStore.userProfile.name ?? ''"
        />
        <div>
          <strong>{{ userProfileStore.userProfile.name }}</strong>
          <div>{{ userProfileStore.userProfile.email }}</div>
        </div>
      </div>
      <CompanySelector class="hidden-lg-and-up hidden-sm-and-down w-100" />
      <v-divider class="mt-4 mb-1" width="100%" />

      <v-list density="compact" class="ma-0">
        <v-list-item
          v-if="!authenticationStore.inOnboarding"
          @click="routeToManageUserProfile"
          rounded
        >
          <template #prepend>
            <AppkitIcon
              class="mr-3"
              icon="icon-cogs-outline"
              size="medium-large"
            />
          </template>
          <v-list-item-title> Manage your account </v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout" id="user-menu__sign-out" rounded>
          <template #prepend>
            <AppkitIcon
              class="mr-3"
              icon="icon-log-out-outline"
              size="medium-large"
              color="var(--dark-grey)"
            />
          </template>
          <v-list-item-title> Sign out </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import AvatarContainer from "@/components/custom/AvatarContainer.vue";
import { RouterPath } from "@/models/enum/routerPath";
import { useUserProfileStore } from "@/stores/userProfileStore";
import { useRouter } from "vue-router";
import { logout } from "@/services/authService";
import CompanySelector from "@/components/CompanySelector.vue";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { useAuthenticationStore } from "@/stores/authentication";

const router = useRouter();
const userProfileStore = useUserProfileStore();
const authenticationStore = useAuthenticationStore();

function routeToManageUserProfile(): void {
  router.push(RouterPath.ManageUserProfile);
}
</script>

<style scoped lang="scss">
.user-menu {
  :deep(.v-overlay__content) {
    border-radius: 6px;
  }
}
</style>
